import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useArchiveWorkspaceMutation } from '@treams/treams-network';
import { Button, Callout, Popover } from '@treams/treams-ui';

import { WorkspaceAdvanced } from './types';

export default function WorkspaceDanger(props: { workspace: WorkspaceAdvanced }) {
	const { t } = useTranslation();

	const [archive] = useArchiveWorkspaceMutation();

	const [visible, setVisible] = useState(false);

	return (
		<Box flexGrow={1} flexBasis={0} mb="1px">
			{!props.workspace.isArchived && (
				<>
					<Callout
						mb={2}
						color="danger"
						title={t('workspaces.edit.danger.archive.warning.title')}
						description={t('workspaces.edit.danger.archive.warning.description')}
					/>
					<Popover.Confirm
						visible={visible}
						title={t('workspaces.edit.danger.archive.warning.description')}
						confirmTitle={t('common.archive')}
						cancelTitle={t('common.cancel')}
						confirmType="destructive"
						onCancel={() => setVisible(false)}
						onConfirm={async () => {
							await archive({ variables: { input: { workspaceID: props.workspace.id } } });
							setVisible(false);
						}}
					>
						<Button
							type="destructive"
							title={t('common.archive')}
							onClick={() => setVisible(true)}
						/>
					</Popover.Confirm>
				</>
			)}
		</Box>
	);
}
